import { render, staticRenderFns } from "./data-home.vue?vue&type=template&id=10e865c2"
import script from "./data-home.vue?vue&type=script&lang=js"
export * from "./data-home.vue?vue&type=script&lang=js"
import style0 from "./data-home.vue?vue&type=style&index=0&id=10e865c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports